import React from 'react';

const Sidebar = ({ setActiveTab }) => {
  return (
    <div style={styles.sidebar}>
      <h2 style={styles.h2}>User Dashboard</h2>
      <ul style={styles.ul}>
        <li style={styles.li} onClick={() => setActiveTab('orders')}>
          My Orders
        </li>
        <li style={styles.li} onClick={() => setActiveTab('profile')}>
          My Profile
        </li>
        <li style={styles.li} onClick={() => setActiveTab('address')}>
          My Address
        </li>
        <li style={styles.li} onClick={() => setActiveTab('password')}>
          Update Password
        </li>
        <li style={styles.li} onClick={() => setActiveTab('logout')}>
          Logout
        </li>
      </ul>
    </div>
  );
};

const styles = {
  sidebar: {
    width: '250px',
    height: '100%',
    backgroundColor: '#000',
    padding: '20px',
    boxShadow: '2px 0 5px rgba(0, 0, 0, 0.1)',
  },
  h2: {
    fontSize: '24px',
    marginTop: '70px',
    color: '#cc9051',
    marginBottom: "20px"
  },
  ul: {
    listStyleType: 'none',
    padding: 0,
  },
  li: {
    margin: '10px 0',
    cursor: 'pointer',
    textDecoration: 'none',
    color: '#cc9051',
    fontSize: '18px',
    fontWeight: 500
  },
};

export default Sidebar;